import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, errMsg } from '../lib/api';

interface ArticleDetail {
  id: string;
  memorialId: string;
  memorialSlug: string;
  deceasedName: string;
  title: string;
  content: string;
  coverKey: string | null;
  createdAt: number;
}

export default function Article() {
  const { articleId } = useParams<{ articleId: string }>();
  const [a, setA] = useState<ArticleDetail | null>(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!articleId) return;
    api<{ article: ArticleDetail }>(`/articles/${articleId}`).then((res) => {
      if (res.ok && res.data) {
        setA(res.data.article);
      } else {
        setErr(errMsg(res, '加载失败'));
      }
      setLoading(false);
    });
  }, [articleId]);

  if (loading) {
    return <p className="p-10 text-center text-sm text-ink-500">加载中…</p>;
  }

  if (err || !a) {
    return (
      <div className="p-10 text-center">
        <p className="text-sm text-ink-500">{err || '文章不存在'}</p>
        <Link to="/" className="mt-4 inline-block text-xs text-ink-500 underline">
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <article className="mx-auto max-w-2xl px-6 py-12">
      <Link to={`/m/${a.memorialSlug}`} className="text-xs text-ink-500 underline">
        ← 返回 {a.deceasedName} 的纪念馆
      </Link>

      <h1 className="mt-6 font-serifcn text-3xl leading-snug text-ink-900">{a.title}</h1>
      <p className="mt-2 text-xs text-ink-500">
        {a.deceasedName} · {new Date(a.createdAt * 1000).toLocaleDateString('zh-CN')}
      </p>

      <div className="mt-8 whitespace-pre-wrap text-[15px] leading-loose text-ink-800">
        {a.content}
      </div>
    </article>
  );
}
